export default __webpack_public_path__ + "static/media/kuchnia3.a329a066.jpg";